import moment, { Moment } from 'jalali-moment';
import { useCallback, useMemo, useState } from 'react';

export interface WeekManagementOptions {
  initDate: Moment;
  limitPrev: number;
  limitNext: number;
}

export default function useWeekManagement(options?: WeekManagementOptions) {
  moment.locale('fa');
  options = {
    initDate: moment().startOf('week'),
    limitPrev: 5,
    limitNext: 4,
    ...(options ?? {})
  };

  const [dateIndex, setDateIndex] = useState(0);
  const [date, setDate] = useState(options.initDate);

  const nextWeek = useCallback(() => {
    if (dateIndex >= options.limitNext) return;
    setDate(d => d.clone().add(1, 'week'));
    setDateIndex(dateIndex + 1);
  }, [options, dateIndex, setDate, setDateIndex]);

  const prevWeek = useCallback(() => {
    if (dateIndex <= -(options.limitPrev)) return;
    setDate(d => d.clone().add(-1, 'week'));
    setDateIndex(dateIndex - 1);
  }, [options, dateIndex, setDate, setDateIndex]);

  const dates = useMemo(() => {
    const result = [];
    for (let i = 0; i < 7; i++) {
      result.push(date.clone().add(i, 'jDay'));
    }
    return result;
  }, [date]);

  return {
    date: date.clone(),
    dates,
    dateIndex,
    dateEN: date.clone().locale('en').format('YYYY-MM-DD'),
    dateFA: date.clone().format('jYYYY-jMM-jDD'),
    nextWeek,
    prevWeek
  };
}
